var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.loading)?_c('LockPlatformPaymentFailed'):_vm._e(),(!_vm.loading)?_c('LockPlatform'):_vm._e(),(!_vm.loading)?_c('LockPlatformNotAcceptedTerms'):_vm._e(),(_vm.$route.meta.showMenuNavigation && !_vm.loading)?_c('Navbar'):_vm._e(),(
      _vm.$route.meta.showActivityNavigation &&
      !_vm.loading
    )?_c('NavbarTopActivity'):_vm._e(),(
      _vm.$route.meta.showWorkflowNavigation &&
      !_vm.loading
    )?_c('NavbarTopWorkflow'):_vm._e(),(_vm.$route.meta.showActivityPageEditNavigation && !_vm.loading)?_c('NavbarTopActivityPageEdit'):_vm._e(),(_vm.$route.meta.showActivityQuizEditNavigation && !_vm.loading)?_c('NavbarTopActivityQuizEdit'):_vm._e(),(_vm.$route.meta.showActivityScormEditNavigation && !_vm.loading)?_c('NavbarTopActivityScormEdit'):_vm._e(),(_vm.$route.meta.showActivityChecklistEditNavigation && !_vm.loading)?_c('NavbarTopActivityChecklistEdit'):_vm._e(),(_vm.$route.meta.showActivitySurveyEditNavigation && !_vm.loading)?_c('NavbarTopActivitySurveyEdit'):_vm._e(),(
      _vm.$route.meta.showInActivityNavigation &&
      !_vm.loading &&
      (_vm.isAuth || (!_vm.isAuth && !_vm.$route.meta.requiresAuth))
    )?_c('NavbarInActivity'):_vm._e(),(_vm.$route.meta.showTopNavigation && !_vm.loading)?_c('NavbarTop'):_vm._e(),(_vm.$route.meta.showHubNavigation && !_vm.loading)?_c('NavbarTopHub'):_vm._e(),(_vm.$route.meta.showCategoryNavigation && !_vm.loading)?_c('NavbarTopCategory'):_vm._e(),_c('v-main',{class:{
      'greyactivitybackground':
        _vm.$route.name == 'ViewActivityQuiz' ||
        _vm.$route.name == 'ViewActivityPage' ||
        _vm.$route.name == 'ViewActivityScorm' ||
        _vm.$route.name == 'ViewActivityChecklist' ||
        _vm.$route.name == 'ViewActivitySurvey',
      'pt-16':
        (_vm.$route.meta.showTopNavigation ||
          _vm.$route.meta.showActivityNavigation ||
          _vm.$route.meta.showHubNavigation ||
          _vm.$route.meta.showCategoryNavigation ||
          _vm.$route.meta.showActivityPageEditNavigation ||
          _vm.$route.meta.showActivityQuizEditNavigation ||
          _vm.$route.meta.showActivityScormEditNavigation ||
          _vm.$route.meta.showActivityChecklistEditNavigation ||
          _vm.$route.meta.showActivitySurveyEditNavigation ) &&
        !_vm.mobile(),
      'pt-14':
        (_vm.$route.meta.showTopNavigation ||
          _vm.$route.meta.showActivityNavigation ||
          _vm.$route.meta.showHubNavigation ||
          _vm.$route.meta.showCategoryNavigation) &&
        _vm.mobile(),
    }},[_c('v-container',{class:{
        'pa-0':
          _vm.$route.name == 'Login' ||
          _vm.$route.name == 'CustomLogin' ||
          _vm.$route.name == 'ViewHub' ||
          _vm.$route.name == 'ViewCategory' ||
          _vm.$route.name == 'ViewActivityPage' ||
          _vm.$route.name == 'ViewActivityScorm' ||
          _vm.$route.name == 'ViewActivityQuiz' ||
          _vm.$route.name == 'ViewActivityChecklist' ||
          _vm.$route.name == 'ViewActivitySurvey' ||
          _vm.$route.name == 'EditActivityPage' ||
          _vm.$route.name == 'EditActivityScorm' ||
          _vm.$route.name == 'EditActivityChecklist' ||
          _vm.$route.name == 'EditActivitySurvey' ||
          _vm.$route.name == 'EditWorkflow' ||
          _vm.$route.name == 'RegistrationGettingStarted',
        'pb-12':
          _vm.$route.name != 'EditWorkflow' &&
          _vm.$route.name != 'EditActivityPage' &&
          _vm.$route.name != 'ViewActivityPage' &&
          _vm.$route.name != 'ViewActivityScorm' &&
          _vm.$route.name != 'ViewActivityQuiz' &&
          _vm.$route.name != 'ViewActivityChecklist' &&
          _vm.$route.name != 'ViewActivitySurvey' &&
          _vm.$route.name != 'EditActivityScorm' &&
          _vm.$route.name != 'EditActivitySurvey' &&
          _vm.$route.name != 'Login' &&
          _vm.$route.name != 'CustomLogin' &&
          _vm.$route.name != 'EditActivityChecklist' &&
          _vm.$route.name != 'RegistrationGettingStarted',
      },staticStyle:{"height":"100%"},attrs:{"fluid":""}},[(!_vm.loading)?_c('router-view',{key:_vm.$route.meta.overrideRouteKey ? '' : _vm.$route.fullPath,staticClass:"fill-height"}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }